import { render, staticRenderFns } from "./SalePayment.vue?vue&type=template&id=65dd3cbe&scoped=true&"
import script from "./SalePayment.vue?vue&type=script&lang=js&"
export * from "./SalePayment.vue?vue&type=script&lang=js&"
import style0 from "./SalePayment.vue?vue&type=style&index=0&id=65dd3cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd3cbe",
  null
  
)

export default component.exports